/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();


$(function(){
  jQuery(".sp-scroll3").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 3,
    scroll: 2,
  });
  
  new Swiper("#sp-swiper3", {
    autoplay: {
      disableOnInteraction: false,
      delay: 2500,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    // centerSlidesBounds: true,
    loop: true,
    pagination: {
      el: ".sp-pagination2",
      type: "bullets",
      clickable: true,
    },
  });
  
  new Swiper("#sp-swiper", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2500,
    },
    loop: true,
    spaceBetween: 20,
  });
})


let spImgList2 = [
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-p1.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-p2.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-p3.png?v=1726913958",
];
let spImgList3 = [
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-p1.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-p2.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-p3.png?v=1726913958",
];
let spImgList4 = [
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-c1.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-c2.png?v=1726913957",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-c3.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202409212-c4.png?v=1726913958",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
    let prods = window.product
    console.log(prods,'prods')
    function getCur(){
        let size = $('#Size div.active').attr('data-val')
             let color = $('#color div.active').attr('data-val')
          return prods.filter(item=> item.option1 == size && item.option2 == color)[0]
        }
        function changePrice(){
          let num = $('#calcNumber').val()
          console.log(getCur(),'getCur()')
          let price = (getCur().price * num / 100).toFixed(2)
          let compare = (getCur().compare_at_price * num / 100).toFixed(2)
          price = (price + '').replace('.', ',')
          compare = (compare + '').replace('.', ',')
          $('#new').html(price)
          $('#old').html(compare)
           let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
          $(".product-part .price3").html(off_font + '% OFF'); 
        }

      $('.sp-btn-style').click(function(){
          let num = $('#calcNumber').val()
          window.location.href = '/cart/' + getCur().id + ':' + num
        })
    //加减
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
      // var number = Number($('#calcNumber').val())
      // $('#new').html((number * Number(9.99)).toFixed(2))
      // $('#old').html((number * Number(15.99)).toFixed(2))
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })

    // style选项
    let typeOptions = $('#color .option')

    // 切换选项
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0756/5570/8954/files/20240924-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0756/5570/8954/files/20240924-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0756/5570/8954/files/20240924-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0756/5570/8954/files/20240924-pro-4.png',
      'https://cdn.shopify.com/s/files/1/0756/5570/8954/files/20240924-pro-5.png',
      'https://cdn.shopify.com/s/files/1/0756/5570/8954/files/20240924-pro-6.png',
    ]
    typeOptions.click(function () {
      let index = $(this).index()
      let index2 = $('#Size .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      chageimgs(index2, index)
      changePrice()
    })
    $('#Size .option').click(function () {
      let index = $(this).index()
      let index2 = $('#color .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      chageimgs(index, index2)
      changePrice()
    })
    function chageimgs(index, index2) {
      if (index2 == 0) {
        $('.top-product>img').attr('src', imgArr[index])
      } else if (index2 == 1) {
        $('.top-product>img').attr('src', imgArr[index + 3])
      }
    }
    addCart()
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
        // do something here
        // var number =
        //   Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
        // $('.sp-cart #cardNum').html(number)
        // if (number >= 1) {
        //   $('.sp-cart .num').css('background', '#D6001A')
        // } else {
        //   $('.sp-cart .num').css('background', '#B4B4B4')
        // }


                // 加购
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        };
        
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
            });
          },
          dataType: "json",
        });
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: '946px',
          height: '580px',
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99999',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 115,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList2);
    preloadImages(spImgList3);
    preloadImages(spImgList4);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            246 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

// 首屏闪烁
let sp_index = 0;
setInterval(function () {
  sp_index += 1;
  sp_index > spImgList2.length - 1 ? (sp_index = 0) : "";
  $(".sp-part1 .sp-img-p")[0].src = spImgList2[sp_index];
}, 1200);

$(".sp-option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项

  let colorOptions = $("#sp-color1 .sp-option.active").index();
  let colorOptions2 = $("#sp-color2 .sp-option.active").index();
  $("#spimg1")[0].src = spImgList[colorOptions];
  $("#spimg2")[0].src = spImgList[colorOptions2];
});

$(".sp-color").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项

  let colorOptions = $(".sp-color-wrap .sp-color.active").index();
  $("#colorImg")[0].src = spImgList[colorOptions];
});



// $(".reduce").click(function () {
//   let input = $(this).siblings("input")[0];
//   let num = Number(input.value) - 1;
//   if (num > 0) {
//     input.value = num;
//   }
// });
// $(".add").click(function () {
//   let input = $(this).siblings("input")[0];
//   let num = Number(input.value) + 1;
//   input.value = num;
// });
// $('.sp-btn-style').click(function(){
//   let num = $(this).siblings('.addGroup').find('input').val()
//   let id = $(this).attr('data-id')
//   window.location.href = '/cart/' + id + ':' + num
// })